module.exports = __webpack_public_path__ + "img/add_template.447b6706.svg";